import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AiUsageDimension } from 'src/app/enums/aiUsageDimension.enum';
import { AiUsageVisibleRow } from 'src/app/models/aiUsageByUser.model';
import { currentMonthStart, shiftMonth } from './ai-usage-by-user.util';

@Injectable()
export class AiUsageByUserState {
  readonly maxMonth: string;

  private readonly monthSubject: BehaviorSubject<string>;
  private readonly groupBySubject = new BehaviorSubject<AiUsageDimension>(AiUsageDimension.Org);
  private visibleRowList: AiUsageVisibleRow[] = [];

  constructor() {
    this.maxMonth = currentMonthStart();
    this.monthSubject = new BehaviorSubject<string>(this.maxMonth);
  }

  get month$(): Observable<string> {
    return this.monthSubject.asObservable();
  }

  get groupBy$(): Observable<AiUsageDimension> {
    return this.groupBySubject.asObservable();
  }

  get month(): string {
    return this.monthSubject.value;
  }

  get groupBy(): AiUsageDimension {
    return this.groupBySubject.value;
  }

  get canStepForward(): boolean {
    return this.month < this.maxMonth;
  }

  get visibleRows(): AiUsageVisibleRow[] {
    return this.visibleRowList;
  }

  stepMonth(delta: number): void {
    const next = shiftMonth(this.month, delta);
    if (next > this.maxMonth) return;
    this.monthSubject.next(next);
  }

  setGroupBy(groupBy: AiUsageDimension): void {
    if (groupBy === this.groupBy) return;
    this.groupBySubject.next(groupBy);
  }

  setVisibleRows(rows: AiUsageVisibleRow[]): void {
    this.visibleRowList = rows;
  }
}
